import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';

const Experience: React.FC = () => {
  const experiences = [
    {
      "title": "AI Software Engineer - AI R&D Team",
      "company": "Veterans United Home Loans",
      "period": "2024 – Present",
      "technologies": ["Python", "LangGraph", "Graph Database", "LLM"],
      "summary": "Leading development of AI-powered internal tools and product integrations.",
      "keyAchievements": [
        "Architected RAG-based chatbots enabling instant company guideline queries",
        "Eliminated manual PDF searches for employees",
        "Spearheading both greenfield AI applications and AI feature integration"
      ]
    },
    {
      "title": "Software Engineer - Conversion Platform",
      "company": "Veterans United Home Loans", 
      "period": "2023 – 2024",
      "technologies": ["C#", "SQL", "Angular", "Microservices"],
      "summary": "Led modernization of company's primary borrower qualification system as Architecture Liaison.",
      "keyAchievements": [
        "Dramatically improved system resiliency through strategic refactoring",
        "Reduced production support burden across core processes",
        "Redesigned build pipeline achieving 75% reduction in build times"
      ],
      "impact": "75% faster builds across platform"
    },
    {
      "title": "Software Engineering Manager - Title Portal Team",
      "company": "Veterans United Home Loans",
      "period": "2022 – 2023",
      "technologies": ["C#", "SQL", "Angular", "TDD", "Team Leadership"],
      "summary": "Led team of 5 developers and QA Engineer delivering secure document-sharing application.",
      "keyAchievements": [
        "Delivered Title Company workflow solution improving efficiency",
        "Served as Architecture Liaison bridging Product Strategy and development",
        "Maintained 95% test coverage using TDD methodologies",
        "Spearheaded hiring process refinements (2020-Present), personally conducting 50+ technical interviews"
      ],
      "impact": "30% increase in loan processing capacity"
    },
    {
      "title": "Software Engineer",
      "company": "Veterans United Home Loans",
      "period": "2020 – 2022",
      "technologies": ["C#", "SQL", "Angular"],
      "summary": "Contributed to title portal development and system improvements as Architecture Liaison.",
      "keyAchievements": [
        "Enhanced alerting and observability systems",
        "Improved outage detection by 30 minutes",
        "Often identified issues before user impact"
      ],
      "impact": "30 minutes faster outage detection"
    }
  ]
;

  return (
    <section id="experience" className="py-5">
      <Container>
        <h2 className="text-center mb-5">Experience</h2>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="timeline">
              {experiences.map((exp, index) => (
                <Card key={index} className="timeline-item mb-4 bg-dark">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h4 className="mb-1 text-light">{exp.title}</h4>
                      <Badge bg="secondary" className="period-badge">{exp.period}</Badge>
                    </div>
                    <h6 className="text-primary mb-3">{exp.company}</h6>
                    
                    <p className="mb-3 text-light">{exp.summary}</p>
                    
                    {exp.keyAchievements && exp.keyAchievements.length > 0 && (
                      <div className="key-achievements mb-3">
                        <h6 className="text-light mb-2">Key Achievements:</h6>
                        <ul className="ps-3 text-light">
                          {exp.keyAchievements.map((achievement, idx) => (
                            <li key={idx}>{achievement}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    {exp.impact && (
                      <div className="impact-section mb-3">
                        <Badge bg="success" className="impact-badge d-inline-block text-break text-start">Impact: {exp.impact}</Badge>
                      </div>
                    )}
                    
                    <div className="d-flex flex-wrap gap-2 mt-3">
                      {exp.technologies.map((tech, idx) => (
                        <Badge key={idx} bg="dark" className="tech-badge border border-secondary">{tech}</Badge>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Experience;
